import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule, ColumnChooserService, PageService, SortService, FilterService, ResizeService } from '@syncfusion/ej2-angular-grids';
import { NgxUiLoaderModule, } from 'ngx-ui-loader';
import { MaskedTextBoxModule, NumericTextBoxAllModule, NumericTextBoxModule } from '@syncfusion/ej2-angular-inputs';
import { MenusNewRoutingModule } from './menus-new-routing.module';
import { MenusNewComponent } from './menus-new.component';
import { NgSelectModule } from '@ng-select/ng-select';
import { FunctionComponent } from './function-code/function-code.component';

@NgModule({
  declarations: [
    MenusNewComponent, FunctionComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    GridModule,
    NgSelectModule,
    NgxUiLoaderModule,
    NumericTextBoxModule,
    NumericTextBoxAllModule,
    MaskedTextBoxModule,
    MenusNewRoutingModule
  ],
  providers: [ColumnChooserService, PageService, SortService, FilterService, , ResizeService],
})
export class MenuNewModule { }
